var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"valor",staticClass:"contrasena",style:(_vm.estilo),on:{"click":_vm.copiarAlPortapapeles}},[_vm._v(" "+_vm._s(_vm.valor)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }